// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Ag-q","productName":"Table_productName__1GwEm"};